import React from 'react';
import {observer} from "mobx-react";
import {ExpandComponentProps} from "core/grid/component/gridComp";
import {action, ObservableMap} from "mobx";
import {GridRow} from "core/grid/domain/grid";
import {Subject} from 'rxjs/Subject';
import 'rxjs/add/operator/mergeMap';
import styled from "styled-components";
import { BrimMessageBlock } from 'core/dataimport/component/brimMessageExpandBlock';
import { ImportEntryBrimMessage } from 'core/dataimport/dataImportDomain';
import dataImportService from 'core/dataimport/dataImportService';

const itemStream = new Subject<any>();
itemStream
  .mergeMap((item) => Promise.all([item, dataImportService.getBrimMessageDetail(item.rowId as number, true)],), null, 5)
  .mergeMap(([item, importEntryBrimMessage]: [GridRow, ImportEntryBrimMessage]) => Promise.all([item, importEntryBrimMessage]))
  .subscribe(action("subscribe-actionCb", ([item, importEntryBrimMessage]: [GridRow, ImportEntryBrimMessage]) => {
  item.rowObject = importEntryBrimMessage;
   item.expanded = 2;
   console.log("BrimMessage resolved event %s", importEntryBrimMessage.brimMessage.messageId);
}));


const MDiv = styled.div`
  margin-left: 24px;
`;


@observer
export default class BrimMessageExpando extends React.Component<ExpandComponentProps, null> {

  
  componentDidMount() {
    let {item} = this.props;
    const importEntryBrimMessage = item.rowObject as ImportEntryBrimMessage;
    if (!importEntryBrimMessage) {
      itemStream.next(item);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    let {item} = this.props;
    const importEntryBrimMessage = item.rowObject as ImportEntryBrimMessage;
    if (!importEntryBrimMessage && prevProps.item.rowId !== item.rowId ) {
      itemStream.next(item);
    }
  }



  render() {
    
    let {item} = this.props;
    const importEntryBrimMessage: ImportEntryBrimMessage = item.rowObject as ImportEntryBrimMessage;
    
      

    console.log("EventExpando render vehicle %s, expanded = %s", (importEntryBrimMessage)?importEntryBrimMessage.brimMessage.messageId:null, item.expanded);

    if (item.expanded === 1) {
      return (
        <MDiv><i className="fa fa-refresh fa-2x fa-spin color-blue-grey-200"/></MDiv>
      );
    }

    return <BrimMessageBlock importEntryBrimMessage={importEntryBrimMessage} />;
  }

}




// WEBPACK FOOTER //
// ./src/core/dataimport/component/brimMessageExpando.tsx